export default {"src":"/_next/static/media/store-google.e0be3c9d.svg","height":40,"width":135,"blurWidth":0,"blurHeight":0};